import angular from 'angular';
import i18n from '../i18n';
import spinnerButtonDirective from './spinner-button-directive';

/**
 * @ngdoc module
 * @name akamai.components.spinner-button
 *
 * @guideline https://design.akamai.com/components/button/
 *
 * @description
 * Spinner button is essentially a submit button that, when submitting a form, shows an
 * indeterminate progress spinner per UXD specifications. For examples of regular buttons,
 * see the [Bootstrap Docs](https://getbootstrap.com/docs/3.3/css/#buttons-tags).
 *
 * @example index.html
 * <akam-spinner-button processing="true"></akam-spinner-button>
 *
 * @example default-button-style.html
 * <akam-spinner-button processing="true" is-primary="false"></akam-spinner-button>
 */
export default angular.module('akamai.components.spinner-button', [
  i18n.name
])

/**
 * @ngdoc directive
 * @name akam-spinner-button
 *
 * @description Creates a spinner-button control
 *
 * @param {string|TranslateKey} [text-content] The text to be displayed on the button
 *
 * @param {Object} [text-content-values] If `TranslateKey` is used for `text-content`, this object
 * hash will be used for translations with variable interpolation. See
 * [angular-translate's translate-value support](https://angular-translate.github.io/docs/#/guide/06_variable-replacement).
 *
 * @param {boolean} [disabled=false] The disabled state of the spinner button
 *
 * @param {boolean} [processing=false] If true, disables the button and shows the spinner.
 *
 * @param {boolean} [isPrimary=true] If true, sets button to btn-primary otherwise btn-default
 */
  .directive('akamSpinnerButton', spinnerButtonDirective);